export default {
  login: '登录',
  switchAccount: '切换为海外帐号',
  passwordLogin: '密码登录',
  messageLogin: '短信验证码登录',
  wxLogin: '扫码登录',
  wxtip: '打开微信，扫一扫',
  phone: '手机',
  password: '密码',
  verificationCode: '验证码',
  getCode: '获取验证码',
  register: '注册',
  forgetPassword: '忘记密码',
  phoneTips: '手机不能为空！',
  passwordTips: '密码不能为空！',
  passwordAgainTips: '请输入密码！',
  passwordInconsistency: '两次密码不一致！',
  codeTips: '验证码不能为空！',
  cellphoneVerity: '手机号不存在，请重新输入',
  innerLogin: '内部员工登录',
  needPassword: '请输入密码',
  instructions: '使用说明',
  browserSupport: '本系统支持浏览器：Chrome(70+)  默认支持1600*900，推荐使用1920*1080分辨率',
  technologyScupport: '技术支持论坛：bbs.ruijie.com.cn',
  contact: '技术服务热线：400-111-000',
  company: '锐捷网络©2021',
  experienceAccount: '产品体验',
  experienceModeTitle: '请选择体验模式',
  customerMode: '进入客户模式',
  partnerMode: '进入合作伙伴模式',
  headOfficeMode: '进入总机构模式',
  smsOnlytip: '该组织仅支持短信验证码登录',
  keepOnRecord: '京ICP备13025710号-1 京公网安备11010802020367号',
  scanCode: '立即扫码',
  startPhoneMaintaince: '开启移动运维'
}
